var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list__container" }, [
    _c("div", { staticClass: "prev", on: { click: _vm.prevSlide } }, [
      _c("img", {
        staticClass: "image",
        attrs: { src: _vm.mediaBaseUrl + _vm.prevReview.image, alt: "" }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "arrow",
        attrs: {
          src: _vm.mediaBaseUrl + "landing/reviews/arrow-left.svg",
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "bg" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "review" }, [
      _c("div", { staticClass: "img" }, [
        _c("img", {
          attrs: { src: _vm.mediaBaseUrl + _vm.activeReview.image, alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "review__wrapper" }, [
        _c("img", {
          attrs: {
            src: _vm.mediaBaseUrl + "landing/reviews/quote.svg",
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "review__content" }, [
          _c("p", [_vm._v(_vm._s(_vm.activeReview.text))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "review__author" }, [
          _c("div", { staticClass: "author__content" }, [
            _c("div", { staticClass: "author__name" }, [
              _vm._v(_vm._s(_vm.activeReview.author))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "review__date" }, [
              _vm._v(_vm._s(_vm.activeReview.date))
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "next", on: { click: _vm.nextSlide } }, [
      _c("img", {
        staticClass: "image",
        attrs: { src: _vm.mediaBaseUrl + _vm.nextReview.image, alt: "" }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "arrow",
        attrs: {
          src: _vm.mediaBaseUrl + "landing/reviews/arrow-right.svg",
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "bg" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "controllers" }, [
      _c("div", { staticClass: "img", on: { click: _vm.prevSlide } }, [
        _c("img", {
          attrs: {
            src: _vm.mediaBaseUrl + "landing/reviews/arrow-left1.svg",
            alt: "arrow left"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img", on: { click: _vm.nextSlide } }, [
        _c("img", {
          attrs: {
            src: _vm.mediaBaseUrl + "landing/reviews/arrow-right1.svg",
            alt: "arrow right"
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }